import { styled, ToggleButton, ToggleButtonGroup } from "@mui/material";
import React from "react";
import { CustomizeSpan } from "../../modules/jobs/style";

const CustomToogle = styled(ToggleButtonGroup)(
  ({ gap, width, customToogle }) => ({
    gap: gap,
    width: width,
    ...customToogle,
  })
);

const Button = styled(ToggleButton)(
  ({
    border,
    isFirst,
    isLast,
    borderRadius,
    padding,
    fontSize,
    color,
    backgroundColor,
    width,
    whiteSpace,
    customStyle,
  }) => ({
    ...(isLast && {
      borderTopRightRadius: `${borderRadius} !important`,
      borderBottomRightRadius: `${borderRadius} !important`,
    }),
    ...(isFirst && {
      borderTopLeftRadius: `${borderRadius} !important`,
      borderBottomLeftRadius: `${borderRadius} !important`,
    }),
    width: width,
    border: `${border}`,
    marginLeft: "0px !important",
    fontWeight: "600",
    gap: "20px !important",
    fontSize: fontSize,
    padding: padding,
    borderRadius: borderRadius,
    color: color,
    backgroundColor: backgroundColor,
    whiteSpace: whiteSpace,
    ...customStyle,
  })
);
const ToogleButton = ({
  alignment,
  handleChange,
  ToogleData,
  border,
  color,
  backgroundColor,
  borderRadius,
  gap,
  padding,
  fontSize,
  activeColor,
  activeBackgroundColor,
  disabled,
  width,
  customStyle,
  whiteSpace,
  customToogle,
}) => {
  return (
    <CustomToogle
      color={"primary"}
      value={alignment}
      exclusive
      gap={gap}
      width={width}
      onChange={handleChange}
      aria-label="Platform"
      customToogle={customToogle}
    >
      {ToogleData.map((item, index) => (
        <Button
          gap={gap}
          borderRadius={borderRadius}
          key={index}
          value={item.value}
          border={border}
          padding={padding}
          fontSize={fontSize}
          isFirst={index === 0}
          color={color}
          width={width}
          startIcon={item?.icon}
          isLast={ToogleData.length - 1 === index}
          backgroundColor={backgroundColor}
          disabled={disabled || item?.disabled}
          whiteSpace={whiteSpace}
          customStyle={customStyle}
          sx={{
            "&.Mui-selected": {
              backgroundColor: `${activeBackgroundColor} !important`,
              color: activeColor,
            },
          }}
        >
          {item?.icon && (
            <CustomizeSpan display={"flex"} alignItems="center">
              {item.icon}
            </CustomizeSpan>
          )}

          {item.name}
        </Button>
      ))}
    </CustomToogle>
  );
};
export default ToogleButton;
